module.exports = __webpack_public_path__ + "static/media/covid_front.5c3ad126.jpg";